import { createContext, useContext, ReactNode } from 'react';
import { User } from 'firebase/auth';
import { UserProfile } from '@shared/types';

interface AuthContextType {
  user: User | null;
  userProfile: UserProfile | null;
  loading: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
  user?: User | null;
  userProfile?: UserProfile | null;
  loading?: boolean;
}

export function AuthProvider({ 
  children, 
  user = null, 
  userProfile = null, 
  loading = false 
}: AuthProviderProps) {
  return (
    <AuthContext.Provider value={{ user, userProfile, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
